module.exports = __webpack_public_path__ + "static/media/linkedin.569eb74a.svg";